import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConstants } from '../app.constants';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Component({
  selector: 'rek-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  justLoggedOut = false;
  justRedirectMyInterviews = false;
  isEnrollmentInactiveInfo = false;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.initIsLogout();
    this.initIsRedirectMyInterviews();
    this.initIsEnrollmentInactive();
  }

  private initIsLogout(): void {
    const isLogoutLocalStorageItemKey = AppConstants.localStorageConstants.isLogout;
    this.justLoggedOut = this.localStorageService.checkExistenceAndRemove(isLogoutLocalStorageItemKey);
  }

  private initIsRedirectMyInterviews(): void {
    const isRedirectMyInterviewsLocalStorageItemKey = AppConstants.localStorageConstants.isRedirectFromMyInterviews;
    this.justRedirectMyInterviews = this.localStorageService.checkExistenceAndRemove(isRedirectMyInterviewsLocalStorageItemKey);
  }

  private initIsEnrollmentInactive(): void {
    this.route.queryParams
      .subscribe(q => {
        this.isEnrollmentInactiveInfo = q.enrollmentIsInactive ?? false;
      });
  }
}
